import { t } from '@citrite/translate';
import { warningConfirmModal } from '@citrite/web-ui-component';

export function offlineModal(): Promise<boolean> {
	return new Promise(userChoseOfflineMode =>
		warningConfirmModal({
			message: t('Workspace:login.offline_prompt.message'),
			confirmButtonText: t('Workspace:login.offline_prompt.confirm_button'),
			cancelButtonText: t('Workspace:login.offline_prompt.cancel_button'),
			onDismiss: () => {
				userChoseOfflineMode(false);
			},
			onCloseSuccess: () => {
				userChoseOfflineMode(true);
			},
			closeOnEscape: false,
			closeOnOverlayClick: false,
		})
	);
}
